module.exports = __webpack_public_path__ + "static/media/GCgreencross_white.969d7af6.png";